import { History, Transition } from "history";
import { useContext, useEffect } from "react";
import { Navigator } from "react-router";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom"; // TODO: To make sure such blocking state can be handled across.

type ExtendNavigator = Navigator & Pick<History, "block">;
export function useBlocker(blocker: (tx: Transition) => void, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;
    // TODO: react-router-dom removed the .block() after version 6.3.0, so this function will need to be updated accordingly
    // https://stackoverflow.com/questions/71572678/react-router-v-6-useprompt-typescript
    try {
      const unblock = (navigator as ExtendNavigator)?.block((tx) => {
        const autoUnblockingTx = {
          ...tx,
          retry() {
            unblock();
            tx.retry();
          },
        };

        blocker(autoUnblockingTx);
      });

      return unblock;
    } catch (e) {
      console.error("[ERROR] Cannot manage blocker, check browser");
    }
  }, [navigator, blocker, when]);
}
